import { type FC, Fragment, type ReactElement } from 'react';
import type { Offer } from '@/interfaces';

export type OfferDestination = Pick<Offer, 'destination' | 'region' | 'country' | 'hotelName'>;

export const Destination: FC<OfferDestination> = ({ destination, region, country, hotelName }): ReactElement<OfferDestination> => {
    const renderDestination = (): string | boolean => {
        const destinationCollection = [destination, region, country].filter(Boolean).join(' / ');
        return destinationCollection.length > 0 && destinationCollection;
    };

    return (
        <Fragment>
            <div className="u-d1 u-stone" data-testid="offerDestination">
                {renderDestination()}
            </div>

            <h2 className="u-b1 u-ma0 u-truncate" data-testid="offerHotelName">
                {hotelName}
            </h2>
        </Fragment>
    );
};
